import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-oncologist-and-hospital',
  templateUrl: './oncologist-and-hospital.component.html',
  styleUrls: ['./oncologist-and-hospital.component.css']
})
export class OncologistAndHospital implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}